export class Lock {
	constructor() {
		this._queue = [];
		this._locked = false;
	}

	lock(cfg) {
		return new Promise((resolve, reject) => {
			let released = false;
			const release = () => {
				if (released) throw new Error('Lock already released');
				released = true;
				const next = this._queue.shift();
				if (next === undefined) this._locked = false;
				else next();
			};

			if (!this._locked) {
				this._locked = true;
				resolve(release);
			} else if (cfg && cfg.timeout) {
				let timeoutId = setTimeout(() => {
					reject(new Error('Lock timeout exceeded'));
					timeoutId = undefined;
				}, cfg.timeout);
				this._queue.push(() => {
					if (timeoutId) {
						clearTimeout(timeoutId);
						timeoutId = undefined;
						resolve(release);
					} else {
						release();
					}
				});
			} else {
				this._queue.push(() => resolve(release));
			}
		});
	}
}
